import { Button, ButtonGroup } from '@progress/kendo-react-buttons';
import { folderOpenIcon, sparklesIcon } from '@progress/kendo-svg-icons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { matchRoutes, useLocation, useNavigate } from 'react-router-dom';
import { Resources } from '../../config/CommonResources';
import { setPortalMode } from '../../store/actions/navActions';
import { PortalMode } from '../../store/reducer/navReducer';
import { RootState } from '../../store/reducer/rootReducer';
import useAppRoutes from '../helpers/RouteHook';

const selectPortalMode = (state: RootState) => state.nav.portalMode;

/**
 * Explore / Agents switch shown in the top navbar. The selected mode lives in Redux so the
 * Dashboard can render the matching view; choosing a mode from any other page returns to Home.
 */
function PortalModeSwitch(): React.ReactElement {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { BaseRoutes, AppRoutes } = useAppRoutes();
  const mode = useSelector(selectPortalMode);

  // Explore/Agents are views of the Home dashboard, so only show a selection while the dashboard itself is on screen
  // (Home or its tag-filtered variant) - on a report or Help page neither mode should look active.
  const matchedPath = matchRoutes(
    AppRoutes.map((r) => ({ path: r.route })),
    pathname,
  )?.[0]?.route.path;
  const onDashboard = matchedPath === BaseRoutes.Home || matchedPath === BaseRoutes.HomeFilter;

  const handleSelect = (next: PortalMode) => {
    dispatch(setPortalMode(next));
    if (!onDashboard) navigate(BaseRoutes.Home);
  };

  return (
    <ButtonGroup className="atlas-mode-toggle">
      <Button togglable selected={onDashboard && mode === 'explore'} svgIcon={folderOpenIcon} onClick={() => handleSelect('explore')}>
        {Resources.Toggle_Explore}
      </Button>
      <Button togglable selected={onDashboard && mode === 'agents'} svgIcon={sparklesIcon} onClick={() => handleSelect('agents')}>
        {Resources.Toggle_Agents}
      </Button>
    </ButtonGroup>
  );
}

export default PortalModeSwitch;
